import React from 'react';
import styled from '@emotion/styled';
import { BookmarkOutlineIcon, CompassIcon, CubeIcon, HandshakeIcon, JigsawIcon, NumbersOutlineIcon, PluralOutlineIcon } from '@seedlang/icons';

const icons = { BookmarkOutlineIcon, CompassIcon, CubeIcon, HandshakeIcon, JigsawIcon, NumbersOutlineIcon, PluralOutlineIcon };

const Wrapper = styled.div`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  margin-right: 15px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.background};
  color: #fff;
  font-size: 28px;
  svg {
    width: 36px;
    height: 36px;
    fill: #fff;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const DeckHistoryThumbnail = ({ deck }) => {
  const thumbnail = deck.thumbnail;
  const Icon = icons[thumbnail.iconName];
  return (
    <Wrapper background={thumbnail.background} aria-hidden="true">
      {thumbnail.imageUrl ? <img src={thumbnail.imageUrl} alt="" /> : thumbnail.text || <Icon />}
    </Wrapper>
  );
};

export default DeckHistoryThumbnail;
